import { FormattedMessage } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'

function TourAsiaCampaignHeroCarouselSubtitle() {
  return <BodyText variant="medium" colour="normal-contrast"><FormattedMessage
    id="Di15glgzPfMjZUiNAlyy"
    defaultMessage="Use code TOURASIA5 for 5% OFF select departures. Limited time only!"
    description="Promotional savings message for tour Asia campaign hero carousel"
  />
  </BodyText>
}

export default TourAsiaCampaignHeroCarouselSubtitle
